import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var PlusCircle = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { d: 'M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z', stroke: 'currentColor', strokeWidth: '2', strokeMiterlimit: '10' }),
    React.createElement("path", { d: 'M6.875 10H13.125', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    React.createElement("path", { d: 'M10 6.875V13.125', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }))); };

export { PlusCircle as default };
//# sourceMappingURL=PlusCircle.js.map
